import { ReactNode } from "react";
import { useKeyboardShortcuts } from "../hooks/useKeyboardShortcuts";

interface KeyboardShortcutsProviderProps {
  children: ReactNode;
}

/**
 * Provider component that enables global keyboard shortcuts
 */
const KeyboardShortcutsProvider: React.FC<KeyboardShortcutsProviderProps> = ({
  children,
}) => {
  // Enable keyboard shortcuts globally
  useKeyboardShortcuts(true);

  return <>{children}</>;
};

export default KeyboardShortcutsProvider;
